import { api } from "./api";

const saleslistApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReturnlist: builder.query({
      query: () => "return",
      providesTags: ["return"],
    }),
    addReturnlist: builder.mutation({
      query: (newData) => ({
        url: "return",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["return"],
    }),
    removeReturnlist: builder.mutation({
      query: (id) => ({
        url: `returnid?return_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["return"],
    }),
  }),
});

export const {
  useGetReturnlistQuery,
  useAddReturnlistMutation,
  useRemoveReturnlistMutation,
} = saleslistApi;